import React from "react";
import { API_BASE } from "../../../../utils/api";

/**
 * Image Upload Section Component
 * Image preview and file upload
 */
const ImageSection = ({
  formData,
  imagePreview,
  errors,
  disabled,
  onFileChange,
}) => {
  return (
    <div className="mb-6">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Product Image
      </label>

      {(imagePreview || formData.imageUrl) && (
        <div className="mb-4">
          <img
            src={imagePreview || `${API_BASE}${formData.imageUrl}`}
            alt="Product"
            className="w-48 h-48 object-cover rounded-lg border-2 border-gray-200 shadow-sm"
          />
        </div>
      )}

      <input
        type="file"
        name="image"
        onChange={onFileChange}
        accept="image/png, image/jpeg, image/jpg, image/gif"
        disabled={disabled}
        className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100 file:cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
      />
      {errors.image && (
        <p className="mt-1 text-sm text-red-600">{errors.image}</p>
      )}

      <label className="flex items-center space-x-3 mt-4 cursor-pointer">
        <input
          type="checkbox"
          className="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-2 focus:ring-blue-500 cursor-pointer disabled:cursor-not-allowed disabled:opacity-50"
          checked={!!formData.isVisible}
          onChange={(e) =>
            onFileChange({
              target: { name: "isVisible", checked: e.target.checked },
            })
          }
          disabled={disabled}
        />
        <span className="text-sm font-medium text-gray-700">Is Available</span>
      </label>
    </div>
  );
};

export default ImageSection;
